export enum OrderingStatusDataModel {
  // These cases all require us to keep the ordering data in store
  VALIDATION_REQUIRED = 'VALIDATION_REQUIRED',
  CONFIRMATION_REQUIRED = 'CONFIRMATION_REQUIRED',
  UNCONFIRMED_ITEMS = 'UNCONFIRMED_ITEMS',

  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  STEP_UP_REQUIRED = 'STEP_UP_REQUIRED',
  NO_CREDIT_TO_ORDER = 'NO_CREDIT_TO_ORDER',
  CWC_FAILED = 'CWC_FAILED',
  SUSPENDED = 'SUSPENDED',
  CEASE_NOT_ALLOWED = 'CEASE_NOT_ALLOWED',
  CANNOT_ORDER = 'CANNOT_ORDER',
  CAPPING_TEMP = 'CAPPING_TEMP',
  PERSONALIZED_MESSAGE = 'PERSONALIZED_MESSAGE',
  ERROR_AIA = 'ERROR_AIA',
  CANCELED = 'CANCELED',
  CANNOT_ORDER_NETFLIX = 'CANNOT_ORDER_NETFLIX',
  ORDERING_CONFIRMATION_MESSAGE = 'ORDERING_CONFIRMATION_MESSAGE',
  CUSTOMER_UNDERAGE = 'CUSTOMER_UNDERAGE',
}

export interface IOrderingError {
  message: string;
}

export interface IOrderingProductOption {
  productId: string;
  action: string;
}

export interface IOrderingProduct {
  productId: string;
  action: string;
  properties: {
    serviceId: string;
  };
  products: Array<IOrderingProductOption>;
}

export interface IOrderingInputVariableQuery {
  channel: string;
  flow: string;
  products: Array<IOrderingProduct>;
}

export interface IOrderingInput {
  orderingInput: IOrderingInputVariableQuery;
  hasIncompatibleOptions: boolean;
  incompatibleOptions: Array<IOrderingProductOption>;
}
